import { ACC_AUDITS_CRUD_ACTION_CREATORS } from '../actions/acc_audits_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';
import { message } from 'antd';
import ACCAuditPipeLineFilters from '../components/asset_cycle_runs_detail_details_page/ACCAuditPipeLineFilters';

const fetchUtils = new FetchUtils();

export const accAuditsRestCrudThunksForBuyer = new RestCrudThunks(
	'asset_cycle_count_audits',
	'accAudit',
	'accAudits',
	'asset_cycle_count_audit',
	ACC_AUDITS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'asset/'
);
export const accAuditsRestCrudThunksForSupplier = new RestCrudThunks(
	'asset_cycle_count_audits',
	'accAudit',
	'accAudits',
	'asset_cycle_count_audit',
	ACC_AUDITS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'asset/'
);

const patchUpdateACCAudit = (suffix) => (roleType) => (accRunId, assetId, entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(ACC_AUDITS_CRUD_ACTION_CREATORS.updateStart(entity));

			const baseUrl = getBackendUri();
			const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_audits/${accRunId}/for_asset/${assetId}/${suffix}`;

			fetchUtils
				.patch(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(ACC_AUDITS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(ACC_AUDITS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(ACC_AUDITS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const patchUpdateACCAuditForNeedsVerification =
	patchUpdateACCAudit('for_needs_verification');
export const patchUpdateACCAuditForMissingAsset = patchUpdateACCAudit('for_missing_asset');

export const updateChangeApplyStatus = (roleType) => (entity, status) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(ACC_AUDITS_CRUD_ACTION_CREATORS.updateStart(entity));

			const baseUrl = getBackendUri();
			const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_audits/${entity.assetCycleCountRunId}/for_asset/${entity.assetId}/change_apply_status/${status}`;

			fetchUtils
				.patch(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(ACC_AUDITS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(ACC_AUDITS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(ACC_AUDITS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const refreshACCAuditCounts = (roleType) => (filters) => (dispatch) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_audits/count_by_change_apply_status`;

	const data = {
		...(filters || {}),
		changeApplyStatuses: ACCAuditPipeLineFilters.map((_) => _.name).join(','),
	};
	fetchUtils
		.get(
			baseUrl + apiUrl,
			Object.assign(
				{
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				},
				data
			)
		)
		.then(parseJSON)
		.then(({ json, status, ok }) => {
			const d = json;
			if (status === 401) {
				dispatch(logoutSuccess());
			}
			if (d.status === 'error') {
				message.error(d.message);
			} else {
				if (d.data && d.data.length > 0) {
					d.data.forEach((category) =>
						dispatch(
							ACC_AUDITS_CRUD_ACTION_CREATORS.countBySuccess(category.count, category.categoryName)
						)
					);
				}
			}
		})
		.catch((d) => {
			message.error(d.message);
		});
};

export const accAuditsCsvReportGenerator = (roleType) => (params) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_audits/csv_report_generator`;

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(
					baseUrl + apiUrl,
					Object.assign(
						{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
						params
					)
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
						message.error(d.data);
					} else {
						resolve(d.data);
						const hide = message.loading(d.data, 0);
						setTimeout(hide, 7000);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};
